import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import { getToken } from "../utils/auth";

const ProtectedRoute: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    return !!getToken();
  });

  useEffect(() => {
    const syncAuth = () => {
      const tokenExists = !!getToken();
      setIsAuthenticated((prev) => (prev !== tokenExists ? tokenExists : prev));
    };

    const intervalId: number = window.setInterval(syncAuth, 1000);
    window.addEventListener("visibilitychange", syncAuth);
    window.addEventListener("focus", syncAuth);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("visibilitychange", syncAuth);
      window.removeEventListener("focus", syncAuth);
    };
  }, []);

  return isAuthenticated ? (
    <>
      <Navbar />
      <div className="pt-17">
        <Outlet />
      </div>
    </>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;
